"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createServer", {
    enumerable: true,
    get: function() {
        return createServer;
    }
});
const _fastify = require("fastify");
const _connectfastify = require("@connectrpc/connect-fastify");
const _createRoutes = require("./createRoutes.js");
async function createServer(lageService, abortController) {
    const server = (0, _fastify.fastify)({
        http2: true
    });
    await server.register(_connectfastify.fastifyConnectPlugin, {
        routes: (0, _createRoutes.createRoutes)(lageService),
        shutdownSignal: abortController.signal,
        compressMinBytes: 512,
        grpc: true
    });
    server.get("/", (_, reply)=>{
        reply.type("text/plain");
        reply.send("lage service");
    });
    return server;
}
